import { __decorate } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import C7nSkeletonButton from 'choerodon-ui/lib/skeleton/Button';
import DataSetComponent from '../data-set/DataSetComponent';
let SkeletonButton = class SkeletonButton extends DataSetComponent {
    render() {
        const { ...otherProps } = this.props;
        const props = {};
        return React.createElement(C7nSkeletonButton, Object.assign({}, otherProps, props));
    }
};
SkeletonButton.dispalyName = 'SkeletonButton';
SkeletonButton = __decorate([
    observer
], SkeletonButton);
export default SkeletonButton;
